import {AfterViewInit, Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { NgxFilterBase} from "../../ngx-filter-base";
import {Filter} from "../../../ngx-types";

@Component({
  selector: 'ngx-true-false-filter',
  templateUrl: '../../ngx-filter-single-template-base.html',
})
export class NgxTrueFalseFilterComponent extends NgxFilterBase implements OnInit, OnDestroy, AfterViewInit {

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
  }

  Label1: string;
  Label2: string;
  @Input() filter: Filter;
  @Output() changeValue = new EventEmitter<any>();

  ngAfterViewInit(): void {
    this.generateComponents(this.filterService.filtersComponent.trueFalse, this.filter.options?.trueFalseOptions);
  }

}
